import { render, staticRenderFns } from "./MortgageListView.vue?vue&type=template&id=132d7e04"
import script from "./MortgageListView.vue?vue&type=script&lang=ts"
export * from "./MortgageListView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports